import React from 'react';
import { SdmDialog } from 'components';

function NoteDialog({ onClose, data, i18n }) {
  return (
    <SdmDialog open onClose={onClose} title={i18n.title} hideAgreeButton>
      <div>{data.note}</div>
    </SdmDialog>
  );
}

export default NoteDialog;
